import React from "react";
import {
  HeaderBar,
  FormInput,
  PasswordInput,
  SubmitButton,
  AuthLink,
  WelcomeMessage,
  ScreenLoader,
} from "@/components/ui";
import { motion } from "framer-motion";
import { useLoginScreenViewModel } from "./LoginScreenViewModel";
import { UI_STYLES } from "@/styles/uiStyles";
import logo from "@/assets/img/icons/logo.svg";
import { Helmet } from "react-helmet-async";

export const LoginScreen: React.FC = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    passwordVisible,
    emailError,
    passwordError,
    togglePasswordVisibility,
    handleSubmit,
    navigateToForgotPassword,
    navigateToRegister,
    error,
    loading,
    } = useLoginScreenViewModel();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="h-full"
    >
      <Helmet>
        <title>Вход в астрологическое приложение | Мир Звёзд</title>
        <meta name="description" content="Войдите в свой аккаунт для доступа к персональным астрологическим прогнозам, картам Таро дня и чату с профессиональным астрологом. Безопасная авторизация в приложении Мир Звёзд." />
        <meta name="keywords" content="вход в приложение, авторизация, астрология, личный кабинет, астрологическое приложение, войти в аккаунт" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Вход в астрологическое приложение | Мир Звёзд" />
        <meta property="og:description" content="Войдите в свой аккаунт для доступа к персональным астрологическим прогнозам и картам Таро дня." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/login" />
      </Helmet>

      <ScreenLoader isLoading={loading} />  
      <div
        className={`flex-1 flex flex-col ${UI_STYLES.backgroundDarkBlue} h-full`}
      >
        <div className="flex flex-col items-center flex-1 px-4 pb-6 w-full max-w-md mx-auto mt-2">
          <HeaderBar title="Вход" />
          <div className="flex flex-col items-center mb-6">
            <img
              src={logo}
              alt="logo"
              className="w-50 h-50 mb-2 mt-4"
            />
          </div>

          <WelcomeMessage
            text="Приветствую вас!"
            className="p-6 rounded-lg"
            textAlign="center"
            showOverlay={false}
          />
          <div className="flex flex-col gap-2 w-full">
            <FormInput
              id="email"
              label="Email"
              type="email"
              value={email}
              onChange={setEmail}
              error={emailError}
            />
            <div className="relative">
              <PasswordInput
                id="password"
                label="Пароль"
                value={password}
                onChange={setPassword}
                error={passwordError}
                visible={passwordVisible}
                onToggleVisibility={togglePasswordVisibility}
              />
              <div
                className="text-white/60 text-end  mb-5 text-xs absolute top-14 right-0 cursor-pointer"
                onClick={navigateToForgotPassword}
              >
                Забыли пароль?
              </div>
            </div>
            <div className="flex flex-col justify-end h-[80px]">
               <div className={`text-red-500 text-sm text-center mb-2 ${error ? "block" : "hidden"}`}>{error}</div>
              <SubmitButton text="Продолжить" onClick={handleSubmit}/>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center flex-1 px-4 pb-6 w-full max-w-[430px] mx-auto mt-2">
          <AuthLink
            question="У вас нет аккаунта?"
            linkText="Зарегистрироваться"
            onClick={navigateToRegister}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default LoginScreen;
